export default __webpack_public_path__ + "static/media/submit.9a5bc30e.svg";